import React from 'react';
import './App.css';

import {
  BrowserRouter as Router,
  Switch,
  Link,
  Route
} from 'react-router-dom'

import {
  Home,
  Pictures,
  Notification,
  Favourites
} from "./pages"

import store from './store'
import { Provider } from 'react-redux'

function App() {
  return (
    <Provider store={store}>
      <Router>
        <nav>
          <div id = "navdiv">
            <div>
              <em> ----- Day by Day in Space -----</em>
            </div>
            <div>
              <Link to="/">Home</Link>
            </div>
            <div>
              <Link to="/pictures">Pictures</Link>
            </div>
            <div>
              <Link to="/favourites">Favourites</Link>
            </div>
            <div>
              <Link to="/notification">Reports</Link>
            </div>
          </div>
        </nav>

        <Switch>
          <Route exact path="/">
            <Home/>
          </Route>
          <Route path="/favourites">
            <Favourites/>
          </Route>
          <Route path="/notification">
            <Notification/>
          </Route>
          <Route path="/pictures">
            <Pictures/>
          </Route>
          
        </Switch>

      </Router>
    </Provider>
  )
}

export default App



